import { CompanyPageSourceDerivedSectionAttributes } from 'api/custom-section/types';
import { PromptInputFormValues } from './types';

export const formValuesIntoAttributes = (
  values: PromptInputFormValues,
  existingAttributes: CompanyPageSourceDerivedSectionAttributes,
): CompanyPageSourceDerivedSectionAttributes => {
  return {
    ...existingAttributes,
    title: values.title ?? existingAttributes.title,
    config: {
      ...existingAttributes.config,
      ...values.config,
    },
  };
};
